import DataHelper from "../../helpers/data.helper";
import { formatDate, formatDateTime } from "../../helpers/dateFormat";
import Collapsible from "../Collapsible/Collapsible.component";
import InitClientsLogic from "./Clients.logic";

const ClientsComponent: React.FC = () => {
    const { selectedClient, clients, typeNames, data, onChange, selectClient, removeSelectedClient } = InitClientsLogic();
    return (
        <div className="page-container">
            <h1 className="text-align-center">Klijenti</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                    <label htmlFor="client">Pretraga klijenata</label>
                    <input placeholder="Traži po imenu ili prezimenu..." id="client" type={"text"} value={data.client} onChange={onChange} name="client"></input>
                </div>
            </div>

            {selectedClient !== undefined && (
                <div className="card" style={{ marginTop: '16px' }}>
                    <button className="btn-secondary" type="button" onClick={() => removeSelectedClient(selectedClient)}>{selectedClient.firstName} {selectedClient.lastName}</button>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
                {clients.map((c) => c.firstName.concat(" ", c.lastName).toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj").includes(data.client.toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj")) ? (
                    <button type="button" key={c.id} onClick={() => selectClient(c)}>{c.firstName} {c.lastName}</button>
                ) : "")
                }
            </div>

            {selectedClient !== undefined && (
                <div style={{ marginTop: '16px' }}>
                    <div className="card text-align-center">
                        <h1>{selectedClient?.firstName} {selectedClient?.lastName}</h1>
                        <p style={{ opacity: 0.8 }}>{selectedClient?.phone}</p>
                    </div>

                    {selectedClient?.packageExpirations?.length > 0 && (
                        <div className="card" style={{ marginTop: '12px' }}>
                            <p style={{ fontWeight: 600, marginBottom: '8px' }}>Aktivni paketi</p>
                            {selectedClient.packageExpirations.map((pkg: any) => (
                                <div key={pkg.trainingCategoryId} style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    gap: '10px',
                                    padding: '6px 0',
                                    borderTop: '1px solid var(--border)',
                                }}>
                                    <span><b>{pkg.categoryName}</b> · stanje: {pkg.counter}</span>
                                    <span style={{ textAlign: 'right', fontSize: '0.9em', opacity: 0.85 }}>
                                        {pkg.expiration ? `ističe ${formatDateTime(pkg.expiration)}` : 'istek nepoznat'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="card" style={{ marginTop: '12px' }}>
                        <Collapsible title="Stanje">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '8px' }}>
                                {(selectedClient?.balanceLog ?? []).length === 0 && (
                                    <p style={{ opacity: 0.6 }}>Nema zabeleženih promena stanja.</p>
                                )}
                                {(selectedClient?.balanceLog ?? []).map((e: any, i: number) => (
                                    <div key={i} style={{ borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>
                                        <p style={{ opacity: 0.7, fontSize: '0.85rem', margin: 0 }}>{formatDateTime(e.createdAt)}</p>
                                        <p style={{ margin: '2px 0' }}><b>{e.label}</b> · {e.categoryName}</p>
                                        <p style={{ margin: 0 }}>{e.delta > 0 ? `+${e.delta}` : e.delta} → stanje {e.newValue}</p>
                                    </div>
                                ))}
                            </div>
                        </Collapsible>
                    </div>

                    <div className="card" style={{ marginTop: '12px' }}>
                        <Collapsible title="Stopiranja">
                            {selectedClient?.holidays?.map((holiday: any) => (
                                <div key={holiday.id} style={{ padding: '4px 0' }}>
                                    <p>{formatDate(holiday.fromDate)} - {formatDate(holiday.toDate)}</p>
                                </div>
                            ))}
                        </Collapsible>
                    </div>

                    <div className="card" style={{ marginTop: '12px' }}>
                        <Collapsible title="Uplate">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
                                {selectedClient?.payments?.map((payment: any) => (
                                    <div key={payment.id} style={{ borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>
                                        <p>{formatDateTime(payment.date)}</p>
                                        <p>{payment.quantity}x {typeNames[payment.trainingTypeId] ?? DataHelper.trainingTypesIdsTrainingTypes[payment.trainingTypeId] ?? ""}</p>
                                        <p>{payment.price}</p>
                                    </div>
                                ))}
                            </div>
                        </Collapsible>
                    </div>

                    <div className="card" style={{ marginTop: '12px' }}>
                        <Collapsible title="Treninzi">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
                                {selectedClient?.trainings?.map((training: any) => (
                                    <div key={training.id} style={{ borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>
                                        <p>{formatDateTime(training.date)}</p>
                                        <p>{DataHelper.trainingTypesIdsTrainingTypesForUser[training.trainingTypeId] ?? typeNames[training.trainingTypeId] ?? ""}</p>
                                        <p>Klijenti:</p>
                                        {training.clients?.map((client: any) => (
                                            <p key={client.id}>{client.firstName} {client.lastName}</p>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </Collapsible>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ClientsComponent;
